import PageHero from '@/components/PageHero';
import { GlassCard } from '@/components/ui/glass-card';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Heart, Sparkles, Users, ArrowRight } from 'lucide-react';

const Behandlungen = () => {
  const treatments = [
    {
      title: "Prana Kundalini-Therapie®",
      description: "Ganzheitliche energetische Behandlung für Körper, Geist und Seele",
      icon: Sparkles,
      features: ["Energiebalancierung", "Chakra-Harmonisierung", "Stressabbau"]
    },
    {
      title: "Energetische Heilung",
      description: "Tiefgreifende Energiearbeit zur Aktivierung der Selbstheilungskräfte",
      icon: Heart,
      features: ["Blockadenlösung", "Vitalitätssteigerung", "Emotionale Balance"]
    },
    {
      title: "Spirituelle Beratung",
      description: "Begleitung auf dem spirituellen Weg und bei Lebensfragen",
      icon: Users,
      features: ["Persönliche Entwicklung", "Bewusstseinserweiterung", "Lebenssinn-Findung"]
    }
  ];

  return (
    <>
      <PageHero 
        title="Behandlungen" 
        description="Energetische Behandlungen und spirituelle Therapien"
        image="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b"
      />
      
      <section className="py-20" style={{ backgroundColor: '#F6E9B2' }}>
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            {/* Introduction */}
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-primary-deep mb-6">
                Unsere Behandlungen
              </h2>
              <p className="text-lg text-gray-700 max-w-3xl mx-auto">
                Entdecken Sie die heilende Kraft der Prana Kundalini-Therapie® und 
                erfahren Sie ganzheitliche Heilung auf allen Ebenen Ihres Seins.
              </p>
            </div>

            {/* Treatment Cards */}
            <div className="grid md:grid-cols-3 gap-8 mb-16">
              {treatments.map((treatment, index) => (
                <GlassCard key={index} className="p-8 text-center">
                  <div className="w-16 h-16 bg-primary-light rounded-full flex items-center justify-center mx-auto mb-4">
                    <treatment.icon className="h-8 w-8 text-primary-deep" />
                  </div>
                  <h3 className="text-xl font-bold text-primary-deep mb-4">
                    {treatment.title}
                  </h3>
                  <p className="text-gray-700 mb-6">
                    {treatment.description}
                  </p>
                  <ul className="space-y-2 text-gray-600">
                    {treatment.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center justify-center">
                        <span className="w-2 h-2 bg-primary-main rounded-full mr-2"></span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </GlassCard>
              ))}
            </div>

            {/* Contact Section */}
            <GlassCard className="p-8 text-center">
              <h3 className="text-2xl font-bold text-primary-deep mb-4">
                Vereinbaren Sie Ihren Termin
              </h3>
              <p className="text-gray-700 mb-6">
                Erfahren Sie die transformative Kraft der energetischen Behandlung. 
                Kontaktieren Sie uns für ein persönliches Beratungsgespräch.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto">
                <Button asChild size="lg" className="bg-primary-main hover:bg-primary-deep">
                  <a href="mailto:sabrina.kure@yahoo.com">
                    Termin anfragen
                  </a>
                </Button>
                <Button asChild size="lg" variant="outline" className="border-primary-main text-primary-main hover:bg-primary-main hover:text-white">
                  <Link to="/anmeldung">
                    Mehr erfahren
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Link>
                </Button>
              </div>
            </GlassCard>
          </div>
        </div>
      </section>
    </>
  );
};

export default Behandlungen;